<template>
  <Container>
    <v-flex justify-start>
      <v-card class="elevation-12">
        <v-toolbar dark tabs>
          <v-btn
            icon
            color="white"
            light
            v-on:click="$router.push('/sequence_game')"
          >
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-toolbar-title v-if="sequenceGameList">{{
            sequenceGameList.category
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="showModalCreate()">
            <v-icon>add</v-icon>New Sequence Game
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            v-if="!isLoadSequenceGame"
            :items="sequenceGameList.sequence_games"
            :headers="headers"
            :search="search"
            :rows-per-page-items="[20, 50, 100]"
          >
            <template v-slot:items="props">
              <td>
                <v-layout justify-center>{{ props.index + 1 }}</v-layout>
              </td>
              <td>
                <v-layout justify-center>{{ props.item.title }}</v-layout>
              </td>
              <td>
                <v-layout justify-center>
                  <v-chip color="primary" text-color="white">{{
                    formatDisplayDifficulty(props.item.difficulty)
                  }}</v-chip>
                </v-layout>
              </td>
              <td>
                <v-layout justify-center>
                  <v-chip color="primary" text-color="white">{{
                    formatDisplayTheme(props.item.theme)
                  }}</v-chip></v-layout
                >
              </td>
              <td>
                <v-layout justify-center>
                  <v-chip color="primary" text-color="white">{{
                    formatDisplayControl(props.item.control)
                  }}</v-chip></v-layout
                >
              </td>
              <td>
                <v-layout justify-center>{{
                  props.item.correct_count
                }}</v-layout>
              </td>
              <td>
                <v-layout justify-center> {{ props.item.updated_at }}</v-layout>
              </td>
              <td>
                <v-layout justify-end>
                  <v-btn
                    icon
                    color="black"
                    @click="onClickAddHomePage(props.item._id)"
                  >
                    <v-icon>home</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    color="black"
                    v-on:click="onClickEdit(props.item._id)"
                  >
                    <v-icon color="white">edit</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    color="red"
                    v-on:click="onClickDelete(props.item._id)"
                  >
                    <v-icon color="white">delete</v-icon>
                  </v-btn>
                </v-layout>
              </td>
            </template>
          </v-data-table>
          <v-progress-linear v-else :indeterminate="true"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-flex>
    <ModalCreateUpdate
      :isOpen="isShowModal"
      :isCreate="isCreate"
      @close="isShowModal = false"
    ></ModalCreateUpdate>
    <HomeDataAssign
      :isOpen="isAddHomepage"
      :gameData="selectedSequenceGame"
      :type="constantHomePage.GameType.PgGame"
      :typePgGame="constantHomePage.typePgGame.SequenceGame"
      @close="isAddHomepage = false"
    ></HomeDataAssign>
  </Container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Container from '../../../components/Container';
import { ModalCreateUpdate } from './components';
import rules from '../../../utils/ruleValidate';
import swal from 'sweetalert2';
import constants from './components/constants';
import HomeDataAssign from '../../HomePage/components/HomeDataAssign.vue';
import constantHomePage from '../../HomePage/constant';

export default {
  name: 'SequenceGame',
  components: {
    Container,
    ModalCreateUpdate,
    HomeDataAssign,
  },
  data() {
    return {
      constants,
      constantHomePage,
      search: '',
      headers: [
        {
          text: 'No.',
          value: 'no.',
          align: 'center',
          sortable: false,
        },
        {
          text: 'title',
          value: 'title',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Difficulty ',
          value: 'difficulty',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Theme',
          value: 'theme',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Control',
          value: 'control',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Correct Count',
          value: 'correct_count',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Updated Date',
          value: 'updated_at',
          align: 'center',
          sortable: false,
        },
      ],
      isCreate: false,
      isShowModal: false,
      rules,
      isAddHomepage: false,
    };
  },
  async mounted() {
    const { id, game_list_id, category_id, sub_id } = this.$route.query;
    if (id) {
      await this.fetchSequenceGameCategory({ sequence_game_id: id });
      this.onClickEdit(id);
    } else if (game_list_id) {
      await this.fetchSequenceGameCategory({
        game_list_id,
      });
    } else if (category_id && sub_id) {
      await this.fetchSequenceGameCategory({
        category_id,
      });
      this.onClickEdit(sub_id);
    }
  },
  computed: {
    ...mapState({
      sequenceGameStore: state => state.sequence_game,
      // sequenceGameList: state => state.sequence_game.sequenceGameList,
      selectedSequenceGame: state => state.sequence_game.selectedSequenceGame,
      isLoadSequenceGame: state => state.sequence_game.isLoadSequenceGame,
      defaultCreate: state => state.sequence_game.defaultCreate,
    }),
    sequenceGameList() {
      const [data] = this.sequenceGameStore.sequenceGameList;
      return data;
    },
  },
  methods: {
    ...mapActions('sequence_game', [
      'fetchSequenceGameCategory',
      'deleteSequenceGame',
      'setStateByKey',
    ]),
    setselectedSequenceGame(id) {
      const [selectedData] = this.sequenceGameList.sequence_games.filter(
        ({ _id }) => _id == id,
      );
      if (selectedData) {
        this.setStateByKey({
          statekey: 'selectedSequenceGame',
          value: selectedData,
        });
      }
    },
    onClickAddHomePage(id) {
      this.setselectedSequenceGame(id);
      this.isAddHomepage = true;
    },
    onClickEdit(id) {
      this.setselectedSequenceGame(id);
      this.setStateByKey({
        statekey: 'updateSequenceGame',
        key: 'id',
        value: id,
      });
      this.isShowModal = true;
      this.isCreate = false;
    },
    onClickDelete(id) {
      swal
        .fire({
          titleText: 'Are you sure.',
          type: 'warning',
          showCancelButton: true,
        })
        .then(result => {
          if (result.value) {
            this.deleteSequenceGame(id);
          }
        });
    },
    formatDisplayTheme(value) {
      if (value >= 0) {
        switch (value) {
          case constants.theme.FOREST:
            return 'FOREST';
          case constants.theme.DESERT:
            return 'DESERT';
          case constants.theme.SEA:
            return 'SEA';
          default:
            return null;
        }
      } else {
        return null;
      }
    },
    formatDisplayDifficulty(value) {
      if (value >= 0) {
        switch (value) {
          case constants.difficulty.EASY:
            return 'EASY';
          case constants.difficulty.NORMAL:
            return 'NORMAL';
          case constants.difficulty.HARD:
            return 'HARD';
          default:
            return null;
        }
      } else {
        return null;
      }
    },
    formatDisplayControl(value) {
      switch (value) {
        case constants.control.DIRECTION:
          return 'DIRECTION';
        case constants.control.STACK:
          return 'STACK';
        case constants.control.MAZE:
          return 'MAZE';
        default:
          return null;
      }
    },
    showModalCreate() {
      this.isShowModal = true;
      this.isCreate = true;
      this.setStateByKey({
        statekey: 'createSequenceGame',
        value: this.defaultCreate,
      });
    },
  },
};
</script>

<style scoped>
.image_thumbnail {
  height: 90px;
  width: 90px;
  margin-top: 15px;
}
.content_img {
  height: 90px;
  width: 90px;
  border-radius: 8px;
}
</style>
